import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { useLevels } from "@dyl/systems/LevelsManager";
import downloadTextFile from '@dyl/utils/downloadTextFile';
import { getToken, getUserResults } from '@dyl/apiClients/backendApi';

export default function useResultsJsonDownload(tokens) {
    const { enqueueSnackbar } = useSnackbar();
    const { globalLevel } = useLevels();

    return useCallback(
        /**
         * @param {string} selectedIds
         */
        async selectedIds => {
            if (!selectedIds?.length) {
                return enqueueSnackbar('No passwords selected', { variant: 'error' });
            }
            else if (selectedIds.length > 1) {
                return enqueueSnackbar('JSON export can only be done for one password at a time.', { variant: 'error' });
            }

            const tokenId = selectedIds[0];

            let token = tokens.find(t => t.token_id === tokenId);

            if (!token) {
                try {
                    token = await getToken(globalLevel.level_id, tokenId);
                }
                catch (error) {
                    return enqueueSnackbar(
                        error.status === 404
                            ? 'Password not found'
                            : 'Error while finding password',
                        { variant: 'error' }
                    );
                }
            }

            const userId = token.user_id;

            if (!userId) {
                return enqueueSnackbar('Password not assigned to a user', { variant: 'error' });
            }

            let array;

            try {
                array = await getUserResults(userId);
            }
            catch {
                return enqueueSnackbar('Failed to get results', { variant: 'error' });
            }

            if (!array?.length) {
                return enqueueSnackbar('No results found', { variant: 'error' });
            }
            else if (array.length > 1) {
                enqueueSnackbar('Unexpectedly found more than one result', { variant: 'warning' });
            }

            downloadTextFile(
                `Results ${tokenId}.json`,
                JSON.stringify(array)
            );
        }, [tokens]
    );
}